import { createMiddleware } from "@tanstack/react-start";

import { isUserRoleInAllowedRoles } from "@onesolution/utils";

import { authMiddleware } from "./auth";

export const rolesCheck = (allowedRoles: string[]) =>
	createMiddleware({ type: "function" })
		.middleware([authMiddleware])
		.server(async ({ next, context }) => {
			if (!isUserRoleInAllowedRoles(context.user.roles, allowedRoles))
				throw new Response("You don't have permission", {
					status: 403,
				});

			return next();
		});
